import { render, staticRenderFns } from "./vcSelectDepartment.vue?vue&type=template&id=878f896c&"
import script from "./vcSelectDepartment.vue?vue&type=script&lang=js&"
export * from "./vcSelectDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports